import consumer from "./consumer"

window.initiateSlidesChannel = function(programReportId, enqueueUrl) {
  console.log(`Trying to connect to channel for programReportId: ${programReportId}`);
  if (!programReportId) return;

  const currentUser = window.dataLayer && window.dataLayer[0] ? window.dataLayer[0].userId : null;

  const subscription = consumer.subscriptions.create({
    channel: "ProgramReportSlidesChannel",
    program_report_id: programReportId,
    requester_id: currentUser
  }, {
    connected() {
      console.log(`Connected`);
      // Subscription confirmed — only now enqueue the job so its broadcast can't beat us to the stream.
      if (enqueueUrl) {
        const token = document.querySelector("meta[name='csrf-token']")?.content;
        fetch(enqueueUrl, { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, "Accept": "application/json" } });
      }
    },
    received(data) {
      console.log(`received; error: ${data.error}, progress: ${data.progress}, url: ${data.download_url}`);
      const slidesConversionModal = document.getElementById("slides-conversion-modal");
      const progressBar = document.getElementById("slides-conversion-progress");
      const progressText = document.getElementById("slides-conversion-progress-text");
      const progressContainer = document.getElementById("slides-conversion-progress-container");
      const successContainer = document.getElementById("slides-conversion-success");
      const errorContainer = document.getElementById("slides-conversion-error");
      const errorMessage = document.getElementById("slides-conversion-error-message");
      const downloadLink = document.getElementById("slides-download-link");

      if (data.progress !== undefined) {
        progressBar.style.width = `${data.progress}%`;
        progressBar.setAttribute("aria-valuenow", data.progress);
        progressText.textContent = `${data.progress}%`;
      }

      if (data.download_url) {
        slidesConversionModal.querySelector(".modal-title").textContent = "Your slides are ready";
        progressContainer.classList.add("d-none");
        downloadLink.href = data.download_url;
        successContainer.classList.remove("d-none");
      } 
      
      if (data.error) {
        slidesConversionModal.querySelector(".modal-title").textContent = "Error generating slides";
        progressContainer.classList.add("d-none");
        errorMessage.textContent = data.error;
        errorContainer.classList.remove("d-none");
      }
    }
  });
  
  $("#slides-conversion-modal").on("hidden.bs.modal", function() {
    subscription.unsubscribe();
    $("#slides-conversion-modal").remove();
  });
  
  return subscription;
};
